import React from "react";
import { Switch } from "react-router-dom";

import Route from "./Route";

import SignIn from "../pages/SignIn";
import Dashboard from "../pages/Dashboard";
import Users from "../pages/Users";
import Support from "../pages/Support";
import Request from "../pages/Request";
import Registry from "../pages/Registry";
import Steps from "../pages/Steps";

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={SignIn} />
    <Route path="/dashboard" isPrivate exact component={Dashboard} />
    <Route path="/users" isPrivate exact component={Users} />
    <Route path="/support" isPrivate exact component={Support} />
    <Route path="/request" isPrivate exact component={Request} />
    <Route path="/registry" isPrivate exact component={Registry} />
    <Route path="/registry/:id" isPrivate  exact component={Steps} />
  </Switch>
);

export default Routes;
